<script>
</script>

<style>
    #landing-page-content-wrapper {
        margin-left: 0;
    }
    .bkg-landing {
        background-image: url("/img/landing-bkg.png");
        min-height: 100vh;
        overflow: hidden;
        background-size: 100%;
        margin-top: -1px;
        background-repeat: no-repeat;

    }

    @media (min-width: 1200px){
        .bkg-landing {
            background-image: url("/img/landing-bkg.png");
            background-size: cover;

        }
    }
</style>
<div class="app-wrapper">
    <div id="landing-page-content-wrapper" class="bkg-landing">
        <slot />
    </div>
</div>
